const staticContent = [
  'ledig',
  'verheiratet',
  'Lebensgemeinschaft',
  'geschieden',
  'verwitwet'
];

module.exports = staticContent;
